// extracted by mini-css-extract-plugin
export default {"pagination":"CompanyPlatoonGroupsWidget_pagination__0PRXp"};